import React, { useRef, useState } from 'react';
import { useRedirect } from '../../hooks/useRedirect';
import Button from '../../components/Button';
import pathnames from '../../routes/index.route';
import RegistrationContent from '../../components/RegistrationContent';
import { FaArrowLeft } from 'react-icons/fa6';
import ContainerCheckBox from '../../components/ContainerCheckBox';
import uk from "../../assets/icons/uk.svg";
import india from "../../assets/icons/india.svg";
import moldova from "../../assets/icons/moldova.svg";
import germany from "../../assets/icons/germany.svg";
import france from "../../assets/icons/france.svg";
import SearchBar from '../../components/SearchBar';
import { InputField } from '../../components/InputField';
import { SelectField } from '../../components/SelectField';
import dataFetcher, { HttpMethod } from '../../apis';
import { GoPlus } from 'react-icons/go';
import SelectOption from '../../components/SelectOption';

const OccupationData = [
  { title: "Content creator" },
  { title: "Teacher & instructor" },
  { title: "Freelancer" },
  { title: "Social media specialist" },
  { title: "Blogger" },
  { title: "Blogger manager" },
  { title: "Student" },
  { title: "Designer" },
  { title: "Marketer" },
  { title: "SMM specialist" },
  { title: "Analyst" },
];

const TeamData = [
  { title: "Solo" },
  { title: "1 — 10" },
  { title: "10 — 50" },
  { title: "50 — 100" },
  { title: "100 — 500" },
];

const ContentData = [
  { title: "Marketing ads" },
  { title: "YouTube videos" },
  { title: "Education content" },
  { title: "SMM content" },
  { title: "Podcasts" },
  { title: "Other" },
];

const lngData = [
  { icon: <img src={uk} alt="flag" />, title: "English" },
  { icon: <img src={germany} alt="flag" />, title: "German" },
  { icon: <img src={india} alt="flag" />, title: "Hindi" },
  { icon: <img src={france} alt="flag" />, title: "French" },
  { icon: <img src={moldova} alt="flag" />, title: "Moldovian" },
  { icon: <img src={uk} alt="flag" />, title: "Belgium" },
  { icon: <img src={france} alt="flag" />, title: "Georgian" },
  { icon: <img src={moldova} alt="flag" />, title: "Moldovian" },
  { icon: <img src={france} alt="flag" />, title: "Belgium" },
  { icon: <img src={germany} alt="flag" />, title: "Georgian" },
];

const genderData = [
  "Male",
  "Female",
  "Other" ,
];

const CompleteProfile = ({ handlePage }: any) => {
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [gender, setGender] = useState("M");
  const [dob, setdob] = useState("2024-05-24");
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      console.log(file);
    }
  };

  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); 
    }
  };

  const handleRemoveClick = (event: any) => {
    event.stopPropagation();
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleSubmitData = async () => {
    setLoading(true);
    console.log(name, phone, gender, dob);
    if (!name || !phone || !gender || !dob) {
      return;
    }
    const formData = new FormData();
    formData.append("name", name);
    formData.append("phone", phone);
    formData.append("gender", "M");
    formData.append("dateOfBirth", dob);
    if (selectedImage) formData.append("profileImage", selectedImage);
    try {
      const response = await dataFetcher({
        url: "/auth/onboard/step/complete-profile",
        method: HttpMethod.POST,
        payload: formData,
      });
      console.log(response);
      setLoading(false);
      if (response.status === 201) {
        handlePage();
      }
    } catch (error) {
      console.error(`Error during complete profile: ${error}`);
      setLoading(false);
    }
  }

  return (
    <>
      <h1 className="text-xl sm:text-4xl text-[#0F0C18] font-medium text-center">
        Complete profile
      </h1>
      <p className="text-center text-sm font-medium text-[#9392A2] my-5">
        Please select all types of content  <br />
        that you are dealing with.
      </p>
      <div className="w-[85%] sm:w-[370px] max-h-[440px] overflow-auto mx-auto custom-scrollbar">
        <p className="text-sm text-[#9392A2] font-medium mb-4">Your photo</p>
        <div onClick={handleDivClick} className="bg-white p-1 flex items-center justify-between rounded-xl px-4 py-2 cursor-pointer">
          <div className="flex items-center gap-3">
            <div className={`w-[48px] h-[48px] flex items-center justify-center border border-[#9392A2] ${!selectedImage && "border-dashed"} rounded-full`} >
              {selectedImage ? (
                <img src={URL.createObjectURL(selectedImage)} alt="Selected" className="w-full h-full object-cover rounded-full" />
              ) : (
                <span><GoPlus /></span>
              )}
            </div>
            <div>
            {selectedImage ? (
              // If an image is selected, display the image name
                <p className="text-sm text-[#9392A2] font-medium">{selectedImage.name}</p>
            ) : (
              // If no image is selected, display the default text content
              <>
                <p className="text-sm text-[#9392A2] font-medium">Add a clear picture so that</p>
                <p className="text-sm text-[#9392A2] font-medium">everybody can recognize you</p>
              </>
            )}
            </div>
          </div>
          {
            selectedImage && <p onClick={handleRemoveClick} className="text-sm text-[#5449f1] font-medium">remove</p>
          }
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleFileChange}
          />
        </div>
        <p className="text-sm text-[#9392A2] font-medium mt-5 mb-4">Other information</p>
        <div className="flex flex-col gap-2">
          <InputField
            label="Full name"
            onTextChange={text => setName(text)}
          />
          <InputField
            label="Phone number"
            onTextChange={text => setPhone(text)}
          />
          <SelectOption options={genderData} onOptionChange={option => setGender(option[0])} label="Gender" />
          <SelectField type="date" label="Birth date" onOptionChange={date => setdob(date)} options={null} />
        </div>
      </div>
      <div className="w-[85%] sm:w-[358px] mx-auto mt-5">
        <Button onClick={handleSubmitData} label="Proceed" loading={loading} />
      </div>
    </>
  );
}

const Workspace = ({ handlePage }: any) => {
  const [name, setName] = useState(""); 
  const [selectedImage, setSelectedImage] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedImage(file);
      console.log(file);
    }
  };

  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); 
    }
  };

  const handleRemoveClick = (event: any) => {
    event.stopPropagation();
    setSelectedImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleSubmitData = async () => {
    setLoading(true);
    if (!name) {
      return;
    }
    const formData = new FormData();
    formData.append("name", name);
    if (selectedImage) formData.append("workspaceImage", selectedImage);
    console.log(formData);
    try {
      const response = await dataFetcher({
        url: "/auth/onboard/step/create-workspace",
        method: HttpMethod.POST,
        payload: formData,
      });
      console.log(response);
      setLoading(false);
      if (response.status === 201) {
        handlePage();
      }
    } catch (error) {
      console.error(`Error during complete profile: ${error}`);
      setLoading(false);
    }
  }

  return (
    <>
      <h1 className="text-xl sm:text-4xl text-[#0F0C18] font-medium text-center">
        Workspace
      </h1>
      <p className="text-center text-sm font-medium text-[#9392A2] my-5">
        Our space is organised by workspaces, so  <br />
        please create one for yourself.
      </p>
      <div className="w-[85%] sm:w-[370px] max-h-[440px] overflow-auto mx-auto custom-scrollbar">
        <p className="text-sm text-[#9392A2] font-medium mb-4">Workspace name</p>
          <InputField
            label="Workspace name"
            onTextChange={text => setName(text)}
          />
        <p className="text-sm text-[#9392A2] font-medium mt-5 mb-4">Other information</p>
        <div onClick={handleDivClick} className="bg-white p-1 flex items-center justify-between rounded-xl px-4 py-2 cursor-pointer">
          <div className="flex items-center gap-3">
            <div className={`w-[48px] h-[48px] flex items-center justify-center border border-[#9392A2] ${!selectedImage && "border-dashed"} rounded-full`} >
              {selectedImage ? (
                <img src={URL.createObjectURL(selectedImage)} alt="Selected" className="w-full h-full object-cover rounded-full" />
              ) : (
                <span><GoPlus /></span>
              )}
            </div>
            <div>
            {selectedImage ? (
              // If an image is selected, display the image name
                <p className="text-sm text-[#9392A2] font-medium">{selectedImage.name}</p>
            ) : (
              // If no image is selected, display the default text content
              <>
                <p className="text-sm text-[#9392A2] font-medium">Add a clear picture so that</p>
                <p className="text-sm text-[#9392A2] font-medium">everybody can recognize you</p>
              </>
            )}
            </div>
          </div>
          {
            selectedImage && <p onClick={handleRemoveClick} className="text-sm text-[#5449f1] font-medium">remove</p>
          }
          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleFileChange}
          />
        </div>
      </div>
      <div className="w-[85%] sm:w-[358px] mx-auto mt-5">
        <Button onClick={handleSubmitData} label="Proceed" loading={loading} />
      </div>
    </>
  );
}

const InitialInfo = () => {
  const navigate = useRedirect();
  const [pageIndex, setPageIndex] = useState(1);
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [selectedContent, setSelectedContent] = useState("");
  const handlePage = () => {
    if (pageIndex === 6) {
      navigate(pathnames.allSet);
      return;
    }
    setPageIndex(pageIndex + 1);
  };
  const handlePageBack = () => {
    if (pageIndex > 1) {
      setPageIndex(pageIndex - 1)
    } else {
      navigate(pathnames.signIn);
    }
  };
  return (
    <section className="lg:flex">
      <RegistrationContent handlePageBack={handlePageBack} path={pathnames.home} />
      <div className="bg-[#F2F0FA] w-full h-screen relative">
        <div
          onClick={handlePageBack}
          className="w-8 h-8 rounded-full bg-white lg:flex items-center justify-center absolute top-8 left-10 cursor-pointer hidden"
        >
          <FaArrowLeft />
        </div>
        <p className="text-base font-medium text-[#9392A2] absolute top-8 right-10">Step {pageIndex} of 6</p>
        <div className="container mx-auto h-full">
          <div className="flex items-center justify-center w-full h-full">
            <div className="w-[100%] sm:w-[558px] mt-8">
              {/* occupation */}
              {
                pageIndex === 1 && (
                  <>
                    <h1 className="text-xl sm:text-4xl text-[#0F0C18] font-medium text-center">
                      What is your occupation?
                    </h1>
                    <p className="text-center text-sm font-medium text-[#9392A2] my-5">
                      Enter or create your account in Dubmate by <br />
                      entering the email or connection services.
                    </p>
                    <div className="w-[85%] sm:w-[370px] max-h-[440px] overflow-auto mx-auto custom-scrollbar">
                      <div className="flex flex-col gap-3 px-[12px]">
                        {OccupationData.map((item, idx) => (
                          <ContainerCheckBox
                            key={idx}
                            title={item.title}
                            selected={selectedOccupation === item.title}
                            onSelect={() => setSelectedOccupation(item.title)}
                          />
                          ))}
                      </div>
                    </div>
                    <div className="w-[85%] sm:w-[358px] mx-auto mt-5">
                      <Button onClick={handlePage} label="Proceed" />
                    </div>
                  </>
                )
              }
              {/* your Team */}
              {
                pageIndex === 2 && (
                  <>
                    <h1 className="text-xl sm:text-4xl text-[#0F0C18] font-medium text-center">
                      What is your Team?
                    </h1>
                    <p className="text-center text-sm font-medium text-[#9392A2] my-5">
                      Tell us about your team, how much  <br />
                      team members do you have?
                    </p>
                    <div className="w-[85%] sm:w-[370px] max-h-[440px] overflow-auto mx-auto custom-scrollbar">
                      <div className="flex flex-col gap-3 px-[12px]">
                        {TeamData.map((item, idx) => (
                          <ContainerCheckBox
                            key={idx}
                            title={item.title}
                            selected={selectedTeam === item.title}
                            onSelect={() => setSelectedTeam(item.title)}
                          />
                          ))}
                      </div>
                    </div>
                    <div className="w-[85%] sm:w-[358px] mx-auto mt-5">
                      <Button onClick={handlePage} label="Proceed" />
                    </div>
                  </>
                )
              }
              {/* content */}
              {
                pageIndex === 3 && (
                  <>
                    <h1 className="text-xl sm:text-4xl text-[#0F0C18] font-medium text-center">
                      What type of content?
                    </h1>
                    <p className="text-center text-sm font-medium text-[#9392A2] my-5">
                      Please select all types of content  <br />
                      that you are dealing with. 
                    </p>
                    <div className="w-[85%] sm:w-[370px] max-h-[440px] overflow-auto mx-auto custom-scrollbar">
                      <div className="flex flex-col gap-3 px-[12px]">
                        {ContentData.map((item, idx) => (
                          <ContainerCheckBox
                            type="radio"
                            key={idx}
                            title={item.title}
                            selected={selectedContent === item.title}
                            onSelect={() => setSelectedContent(item.title)}
                          />
                          ))}
                      </div>
                    </div>
                    <div className="w-[85%] sm:w-[358px] mx-auto mt-5">
                      <Button onClick={handlePage} label="Proceed" />
                    </div>
                  </>
                )
              }
              {/* Language */}
              {
                pageIndex === 4 && (
                  <>
                    <h1 className="text-xl sm:text-4xl text-[#0F0C18] font-medium text-center">
                      Language
                    </h1>
                    <p className="text-center text-sm font-medium text-[#9392A2] my-5">
                      Help us to make you convenient user experience. <br />
                      What is your native language?
                    </p>
                    <SearchBar placeholder="Search language" className="w-[85%] sm:w-[350px] mx-auto bg-white mb-3" />
                    <div className="w-[85%] sm:w-[370px] max-h-[440px] overflow-auto mx-auto custom-scrollbar">
                      <div className="flex flex-col gap-3 px-[12px]">
                        {lngData.map((item, idx) => (
                          <ContainerCheckBox
                            icon={item.icon}
                            key={idx}
                            title={item.title}
                            selected={selectedLanguage === item.title}
                            onSelect={() => setSelectedLanguage(item.title)}
                          />
                          ))}
                      </div>
                    </div>
                    <div className="w-[85%] sm:w-[358px] mx-auto mt-5">
                      <Button onClick={handlePage} label="Proceed" />
                    </div>
                  </>
                )
              }
              {/* Complete profile */}
              {
                pageIndex === 5 && <CompleteProfile handlePage={handlePage} />
              }
              {/* Workspace */}
              {
                pageIndex === 6 && <Workspace handlePage={handlePage} />
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InitialInfo;